var map = {
	"./Aaron Burr - 1796.jpg": 425,
	"./Aaron Burr - 1800.jpg": 426,
	"./Abraham Lincoln (I) - 1864.jpg": 427,
	"./Abraham Lincoln - 1860.jpg": 428,
	"./Adlai Stevenson - 1952.jpg": 429,
	"./Adlai Stevenson - 1956.jpg": 430,
	"./Al Smith - 1928.jpg": 431,
	"./Albert Gore, Jr. - 2000.jpg": 432,
	"./Alfred M. Landon - 1936.jpg": 433,
	"./Allan Benson - 1916.jpg": 434,
	"./Allan Benson - 1920.jpg": 435,
	"./Alton B. Parker - 1904.jpg": 436,
	"./Andrew Jackson (I) - 1832.jpg": 437,
	"./Andrew Jackson - 1824.jpg": 438,
	"./Andrew Jackson - 1828.jpg": 439,
	"./B. Gratz Brown - 1872.jpg": 440,
	"./Barack H. Obama - 2008.jpg": 441,
	"./Barack H. Obama - 2012.jpg": 442,
	"./Barry M. Goldwater - 1964.jpg": 443,
	"./Benjamin Harrison (I) - 1892.jpg": 444,
	"./Benjamin Harrison - 1888.jpg": 445,
	"./Calvin Coolidge (I) - 1924.jpg": 446,
	"./Charles C. Pinckney - 1800.jpg": 447,
	"./Charles C. Pinckney - 1804.jpg": 448,
	"./Charles C. Pinckney - 1808.jpg": 449,
	"./Charles E. Hughes - 1916.jpg": 450,
	"./Charles J. Jenkins - 1872.jpg": 451,
	"./Daniel Webster - 1836.jpg": 452,
	"./David Davis - 1872.jpg": 453,
	"./De Witt Clinton - 1812.jpg": 454,
	"./Donald J. Trump - 2016.jpg": 455,
	"./Dr. Evan McMullin - 2016.jpg": 456,
	"./Dwight D. Eisenhower (I) - 1956.jpg": 457,
	"./Dwight D. Eisenhower - 1952.jpg": 458,
	"./Eugene Debs - 1904.jpg": 459,
	"./Eugene V. Debs - 1912.jpg": 460,
	"./Franklin D. Roosevelt (I) - 1936.jpg": 461,
	"./Franklin D. Roosevelt (I) - 1940.jpg": 462,
	"./Franklin D. Roosevelt (I) - 1944.jpg": 463,
	"./Franklin D. Roosevelt - 1932.jpg": 464,
	"./Franklin Piece - 1852.jpg": 465,
	"./Gary E. Johnson - 2012.jpg": 466,
	"./Gary E. Johnson - 2016.jpg": 467,
	"./George B. McClellan - 1864.jpg": 468,
	"./George C. Wallace - 1968.jpg": 469,
	"./George Clinton - 1792.jpg": 470,
	"./George Clinton - 1808.jpg": 471,
	"./George H. W. Bush (I) - 1992.jpg": 472,
	"./George H. W. Bush - 1988.jpg": 473,
	"./George McGovern - 1972.jpg": 474,
	"./George W. Bush (I) - 2004.jpg": 475,
	"./George W. Bush - 2000.jpg": 476,
	"./George Washington (I) - 1792.jpg": 477,
	"./George Washington - 1788.jpg": 478,
	"./Gerald R. Ford (I) - 1976.jpg": 479,
	"./Grover Cleveland - 1884.jpg": 480,
	"./Grover Cleveland - 1888.jpg": 481,
	"./Grover Cleveland - 1892.jpg": 482,
	"./Harry F. Byrd - 1960.jpg": 483,
	"./Harry S. Truman (I) - 1948.jpg": 484,
	"./Henry Clay - 1824.jpg": 485,
	"./Henry Clay - 1832.jpg": 486,
	"./Henry Clay - 1844.jpg": 487,
	"./Henry Wallace - 1948.jpg": 488,
	"./Herbert Hoover (I) - 1932.jpg": 489,
	"./Herbert Hoover - 1928.jpg": 490,
	"./Hillary R. Clinton - 2016.jpg": 491,
	"./Horace Greeley - 1872.jpg": 492,
	"./Horatio Seymour - 1868.jpg": 493,
	"./Hubert H. Humphrey - 1968.jpg": 494,
	"./Hugh L. White - 1836.jpg": 495,
	"./J. Storm Thurmond - 1948.jpg": 496,
	"./James A. Garfield - 1880.jpg": 497,
	"./James B. Weaver - 1880.jpg": 498,
	"./James B. Weaver - 1892.jpg": 499,
	"./James Buchanan - 1856.jpg": 500,
	"./James G. Blaine - 1884.jpg": 501,
	"./James K. Polk - 1844.jpg": 502,
	"./James M. Cox - 1920.jpg": 503,
	"./James Madison (I) - 1812.jpg": 504,
	"./James Madison - 1808.jpg": 505,
	"./James Monroe (I) - 1820.jpg": 506,
	"./James Monroe - 1816.jpg": 507,
	"./Jill E. Stein - 2016.jpg": 508,
	"./Jimmy Carter (I) - 1980.jpg": 509,
	"./Jimmy Carter - 1976.jpg": 510,
	"./John Adams (I) - 1800.jpg": 511,
	"./John Adams - 1788.jpg": 512,
	"./John Adams - 1792.jpg": 513,
	"./John Adams - 1796.jpg": 514,
	"./John Anderson - 1980.jpg": 515,
	"./John Bell - 1860.jpg": 516,
	"./John C. Beckinridge - 1860.jpg": 517,
	"./John C. Frémont - 1856.jpg": 518,
	"./John F. Kennedy - 1960.jpg": 519,
	"./John F. Kerry - 2004.jpg": 520,
	"./John Floyd - 1832.jpg": 521,
	"./John P. Hale - 1852.jpg": 522,
	"./John Quincy Adams (I) - 1828.jpg": 523,
	"./John Quincy Adams - 1820.jpg": 524,
	"./John Quincy Adams - 1824.jpg": 525,
	"./John S. McCain - 2008.jpg": 526,
	"./John W. Davis - 1924.jpg": 527,
	"./Lewis Cass - 1848.jpg": 528,
	"./Lyndon B. Johnson (I) - 1964.jpg": 529,
	"./Martin Van Buren (I) - 1840.jpg": 530,
	"./Martin Van Buren - 1836.jpg": 531,
	"./Martin Van Buren - 1848.jpg": 532,
	"./Michael S. Dukakis - 1988.jpg": 533,
	"./Millard Fillmore - 1856.jpg": 534,
	"./Ralph Nader - 2000.jpg": 535,
	"./Richard M. Nixon (I) - 1972.jpg": 536,
	"./Richard M. Nixon - 1960.jpg": 537,
	"./Richard M. Nixon - 1968.jpg": 538,
	"./Robert Dole - 1996.jpg": 539,
	"./Robert M. La Follette Sr. - 1924.jpg": 540,
	"./Ronald Reagan (I) - 1984.jpg": 541,
	"./Ronald Reagan - 1980.jpg": 542,
	"./Ross Perot - 1992.jpg": 543,
	"./Ross Perot - 1996.jpg": 544,
	"./Rufus King - 1816.jpg": 545,
	"./Rutherford B. Hayes - 1876.jpg": 546,
	"./Samuel J. Tilden - 1876.jpg": 547,
	"./Stephen A. Douglas - 1860.jpg": 548,
	"./Theodore Roosevelt (I) - 1904.jpg": 549,
	"./Theodore Roosevelt - 1912.jpg": 550,
	"./Thomas A. Hendricks - 1872.jpg": 551,
	"./Thomas E. Dewey - 1944.jpg": 552,
	"./Thomas E. Dewey - 1948.jpg": 553,
	"./Thomas Jefferson - 1796.jpg": 554,
	"./Thomas Jefferson - 1800.jpg": 555,
	"./Thomas Jefferson - 1804.jpg": 556,
	"./Thomas Pinckney - 1796.jpg": 557,
	"./Ulysses S. Grant (I) - 1872.jpg": 558,
	"./Ulysses S. Grant - 1868.jpg": 559,
	"./W. Mitt Romney - 2012.jpg": 560,
	"./Walter F. Mondale - 1984.jpg": 561,
	"./Warren G. Harding - 1920.jpg": 562,
	"./Wendell L. Willkie - 1940.jpg": 563,
	"./William H. Crawford - 1824.jpg": 564,
	"./William H. Harrison - 1836.jpg": 565,
	"./William H. Harrison - 1840.jpg": 566,
	"./William Howard Taft (I) - 1912.jpg": 567,
	"./William Howard Taft - 1908.jpg": 568,
	"./William J. Clinton (I) - 1996.jpg": 569,
	"./William J. Clinton - 1992.jpg": 570,
	"./William Jennings Bryan - 1896.jpg": 571,
	"./William Jennings Bryan - 1900.jpg": 572,
	"./William Jennings Bryan - 1908.jpg": 573,
	"./William McKinley - 1896.jpg": 574,
	"./William McKinley - 1900.jpg": 575,
	"./William Wirt - 1832.jpg": 576,
	"./Willie Person Mangum - 1836.jpg": 577,
	"./Winfield Scott - 1852.jpg": 578,
	"./Winfield Scott Hancock - 1880.jpg": 579,
	"./Woodrow Wilson (I) - 1916.jpg": 580,
	"./Woodrow Wilson - 1912.jpg": 581,
	"./Zachary Taylor - 1848.jpg": 582
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 424;


//////////////////
// WEBPACK FOOTER
// ./src/img/us ^\.\/.*\.jpg$
// module id = 424
// module chunks = 0